export default __webpack_public_path__ + "static/media/filter-outline-16px-w.373c171c.svg";